<template>
  <div :class='"rf-status rf-tamanho-" + cpntTamanho'>
    <!-- APRESENTA O CARREGANDO -->
    <template v-if='cpntStatus === "carregando"'>
      <i v-if='cpntIcone' class="fas fa-circle-notch fa-spin"></i>

      <div class="loadding">
        <div></div>
        <div></div>
        <div></div>
      </div>

    </template>

    <!-- APRESENTA A MENSAGEM DE ERRO OU STATUS -->
    <template v-else-if='typeof cpntStatus === "object"'>
      <!-- MOSTRA O ICONE COM O ERRO -->
      <i class="fa fa-exclamation-circle"></i>
      <!-- FAZ QUEBRA DE LINHA SE O ICONE FOR INFORMADO -->
      <br/>

      <!-- VERIFICA SE DEVE INFORMAR EM QUAL PLATAFORMA DEU O ERRO -->
      <b v-if="cpntStatus.hasOwnProperty('loc')" v-html='cpntStatus.loc'></b>

      <!-- VERIFICA SE DEVE INFORMAR EM QUAL PLATAFORMA DEU O ERRO -->
      <b v-if="cpntStatus.hasOwnProperty('cod')" v-html='" [" + cpntStatus.cod + "]: "'></b>
      <b v-else-if="cpntStatus.hasOwnProperty('code')" v-html='" [" + cpntStatus.code + "]: "'></b>

      <!-- APRESENTA A MENSAGEM DE ERRO -->
      <span v-if="cpntStatus.hasOwnProperty('err')" v-html='cpntStatus.err'></span>
      <span v-else-if="cpntStatus.hasOwnProperty('message')" v-html='cpntStatus.message'></span>

      <!-- APRESENTA A MENSAGEM DE ERRO -->
      <template v-if='cpntStatus.hasOwnProperty("html")'>
        <div v-if="typeof cpntStatus.html === 'object' && cpntStatus.html.hasOwnProperty('message')" class='rf-status-erro-html' v-html='cpntStatus.html.message'></div>

        <div v-else class='rf-status-erro-html' style="text-align: left;" v-html='cpntStatus.html' v-show='VUE_APP_DOMAIN === "192.168.0.99"'></div>
      </template>

    </template>

    <!-- APRESENTA A MENSAGEM QUE O ERRO NÃO FOI IDENTIFICADO -->
    <template v-else-if='cpntStatus !== "" && cpntStatus !== null'>
      <i v-if='cpntIcone' class="fa fa-exclamation-circle"></i>
      <br/>
      <b>Erro não identificado</b>
      ({{ cpntStatus }})
    </template>
  </div>
</template>

<style scoped>
  @keyframes blink {
    0% {
      opacity: .2;
    }
    20% {
      opacity: 1;
    }
    100% {
      opacity: .2;
    }
  }

  .loadding > div {
    background: #888;
    border-radius: 7px;
    height: 7px;
    width: 7px;
    display: inline-block;
    margin: 0px 2px;

    animation-name: blink;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;
  }

  .loadding > div:nth-child(2) {
    animation-delay: .2s;
  }
  .loadding > div:nth-child(3) {
    animation-delay: .4s;
  }


  .fa-spin {
    -webkit-animation: fa-spin 0.6s infinite linear;
    animation: fa-spin 0.6s infinite linear;
  }
  .rf-status {
    text-align: center;
    color: var(--color-base-02);
  }
  .rf-tamanho-1 svg {
    font-size: var(--font-base-soma-18);
  }
  .rf-tamanho-2 svg {
    font-size: var(--font-base-soma-36);
  }
  .rf-tamanho-3 svg {
    font-size: var(--font-base-soma-54);
  }
  .rf-tamanho-4 svg {
    font-size: var(--font-base-soma-72);
  }
  .rf-tamanho-5 svg {
    font-size: var(--font-base-soma-90);
  }

  .rf-erro {
    width: 350px; 
    margin: 0 auto; 
    padding: 20px 0px 15px 0px;
  }
    .rf-erro > svg.fa-exclamation-circle {
      color: #f44336;
      margin-bottom: 15px;
    }

  .rf-status-erro-html {
    margin-top: 20px;
  }
</style>

<script>
  export default {
    name: 'RF-Status',
    props: {
      cpntStatus: {
        required: true,
        type: [ String, Object ]
      },
      cpntTamanho: {
        required: false,
        default: function () {
          return 5
        }
      },
      cpntFrase: {
        required: false,
        type: Boolean,
        default: function () {
          return true
        }
      },
      cpntIcone: {
        required: false,
        type: Boolean,
        default: function () {
          return false
        }
      }
    },
    data: function () {
      return {
        VUE_APP_DOMAIN: process.env.VUE_APP_DOMAIN
      }
    }
  }
</script>
